// this file runs after the DOMContentLoaded event,
// but before the app is rendered
import { init as initClientData } from './utils/client-data'

initClientData()
